import { createStore } from 'vuex';
import userAuth from './modules/userAuth.module';
import catalogs from './modules/catalogs.module';
import cart from './modules/cart.module';
import semaphore from './modules/semaphore.module';
import resources from './modules/resources.module';

export default createStore({
  modules: {
    userAuth,
    catalogs,
    cart,
    semaphore,
    resources
  }
})
